import type { DeleteCustomerResponse } from '@vy/api-definition';
import { DeleteCustomerResponseSchema } from '@vy/api-definition';
import type { WeftApi } from '@vy/client';
import type { UseMutationOptions } from 'react-query';
import { useMutation } from 'react-query';
import { getPrivateApi } from '../../services/api';

type UseDeleteCustomerPayload = Parameters<WeftApi['deleteCustomer']>[0];

export function useDeleteCustomer(
  options?: UseMutationOptions<DeleteCustomerResponse, unknown, UseDeleteCustomerPayload['customerId']>,
) {
  return useMutation({
    mutationFn: async (customerId) => {
      const api = getPrivateApi();

      const deleteCustomerResponse = await api.deleteCustomer({ customerId });

      return DeleteCustomerResponseSchema.parse(deleteCustomerResponse);
    },
    ...options,
  });
}
